<template>
  <div class="addMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-card shadow="never" style="min-height:auto">
      <div class="cardTop">
        <!-- <h1>{{ rulesInfo.name }}</h1> -->
        <div class="head">
          <span style="font-size: 22px;">{{ rulesInfo.name}}</span>
          <div class="describe">
            <span style="padding:10px 0; ">规则说明:</span>
            <span>①先满足触发条件，再过滤条件，最后执行动作。</span>
            <span>②触发条件与过滤条件为and关系。</span>
            <span>③触发条件为‘设备触发’则过滤条件只能是‘时间过滤’，触发条件为‘设备离线触发’则过滤条件只能是‘状态持续时长’。</span>
          </div>
          <!-- <div style="width: 44%;">
            <el-tooltip effect="dark" placement="right-start">
              <div slot="content" class="rightCenter">
                <div class="describe">
                  <span style="padding-bottom:  10px;">规则说明:</span>
                  <span>①先满足触发条件，再过滤条件，最后执行动作。</span>
                  <span>②触发条件与过滤条件为and关系。</span>
                  <span>③触发条件为‘设备触发’则过滤条件只能是‘时间过滤’，触发条件为‘设备离线触发’则过滤条件只能是‘状态持续时长’。</span>
                </div>

              </div>
              <i class="el-icon-warning" style="font-size: 20px; color: #fff; padding-left :5px "></i>
            </el-tooltip>
          </div> -->

        </div>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3>{{ rulesInfo.remark }}</h3>

        </div>
        <el-form ref="addForm" :model="addForm">

          <!--  ***********************触发条件***********************   -->

          <el-form-item label="">
            <div class="trigger">
              <span slot="label">触发条件</span>
              <el-tooltip effect="dark" placement="right-start">
                <i class="el-icon-warning" style="font-size:18px; padding-left: 5px; color:red"></i>
                <div slot="content" class="rightCenter">
                  <div class="describe">
                    <span style="padding-bottom:  10px;">触发条件:</span>
                    <span>①设备触发：当设备达到预设的条件则触发指定的动作，设备触发条件可以多个，多个条件为and关系。</span>
                    <span>②设备离线触发：当设备离线则触发指定的动作，设备离线触发条件只有一个。</span>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <br />
            <div class="terms" v-for="(item, index) in addForm.platformRuleTriggerAddDtoList" :key="index">
              <div class="subheading">触发条件{{ index + 1 }}</div>
              <img @click="delPlatformRuleTriggerAddDto(item, index)" src="../../assets/images/error.png" alt="">
              <el-select v-model="item.type" filterable placeholder="未选择" @change="changeType($event, item)">
                <el-option v-for="items in platformRuleTriggerTypelist" :key="items.value" :label="items.label"
                  :value="items.value" :disabled='items.disabled'>
                </el-option>
              </el-select>
              <!-- 时间触发数据 -->
              <!-- <div v-if="item.type==2">
                <el-input v-model="item.cron" placeholder="请输入cron表达式"></el-input>
                <div class="subheading">
                  Cron表达式填写方式：Cron表达式仅支持5位，不支持秒；您可以参考
                  <el-button type="text" @click="cronDetail" style="float:none">详细表达式</el-button>
                  <br>
                  <el-button type="text" @click="cronConvert" style="float:none">CRON转换器</el-button>
                </div>
              </div> -->

              <el-input v-if="item.type == 2" v-model="item.cronInstruction" placeholder="可对cron表达式进行备注说明"></el-input>
              <!-- 设备触发数据 -->
              <!-- <el-input v-model="item.devName" placeholder="请选择设备" @select="showSelect(platformRuleTriggerAddDtoLists, item.key)"></el-input> -->
              <span class="selectDiv" v-if="item.type == 1"
                @click="showSelect(platformRuleTriggerAddDtoLists, item.key)" style="width: 300px;">
                <span class="devicename"> {{ item.devName == null ? '请选择设备' : item.devName }}</span> <!--设备名称 -->

                <span v-show="false">{{ item.devId }}</span> <!-- 设备id -->
              </span>
              <!-- 离线设备触发 -->
              <span class="selectDivdevName" v-if="item.type == 3" @click="showSelect(offlineAddDtoLists, item.key)">
                <span> {{ item.devName == null ? '请选择设备' : item.devName }}</span><!-- 设备名称-->
                <span v-show="false">{{ item.devId }}</span> <!-- 设备id -->
              </span>
              <!-- 根据设备id获取包体字段 -->
              <el-select v-if="item.type == 1" v-model="item.devProtocolPacketFieldCode" filterable
                placeholder="请选择包体属性" @change="changePacketField($event, item)">
                <el-option v-for="items in item.packetFieldRuleVoList" :key="items.code" :label="items.name"
                  :value="items.code">
                </el-option>
              </el-select>
              <!-- 比较模式 -->
              <el-select v-if="item.packetFieldDataType == 1" v-model="item.checkOperate" filterable
                placeholder="请选择比较模式">
                <el-option v-for="items in comparativeModeList" :key="items.value" :label="items.label"
                  :value="items.value">
                </el-option>
              </el-select>
              <el-input v-if="item.packetFieldDataType === 1 && item.checkOperate === 7||item.checkOperate === 8"
                v-model="item.startValue" placeholder="请输入开始值" />
              <el-input v-if="item.packetFieldDataType == 1 && item.checkOperate === 7||item.checkOperate === 8"
                v-model="item.endValue" placeholder="请输入结束值" />
              <el-input v-if="item.packetFieldDataType == 1 && item.checkOperate !==7  && item.checkOperate !==8"
                v-model="item.startValue" placeholder="请输入比较值" />
            </div>
            <el-button v-if="!facilityOff" class="addCreationBtn" plain
              @click="addPlatformRuleTriggerAddDto">添加触发条件</el-button>
          </el-form-item>

          <!--  ***********************过滤条件***********************   -->

          <el-form-item label="">
            <div class="trigger">
              <span slot="label">过滤条件</span>
              <el-tooltip effect="dark" placement="right-start">
                <i class="el-icon-warning" style="font-size:18px;padding-left: 5px; color:red  "></i>
                <div slot="content" class="rightCenter">
                  <div class="describe">
                    <span style="padding-bottom:  10px;">过滤条件 :</span>
                    <span>①时间过滤(此条件只在设备触发条件下才能设置)：设置了该条件后，则在设置的时间段内才会执行动作，时间过滤条件可以多个，多个条件为or关系。</span>
                    <span>②状态持续时长(此条件只在设备离线条件触发下才能设置)：设置了该条件后，则表示设备离线持续了设定的时长(分钟)后才触发指定的动作</span>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <br />
            <div class="terms" v-for="(item, index) in addForm.platformRuleFilterAddDtoList" :key="index">
              <div class="subheading">过滤条件{{ index + 1 }}</div>
              <img @click="delPlatformRuleFilterAddDto(item, index)" src="../../assets/images/error.png" alt="">
              <el-select v-model="item.type" filterable placeholder="未选择" @change="changeType1($event, item)">
                <el-option v-show="!facilityOff" v-for="items in platformRuleFilterTypelist" :key="items.value"
                  :label="items.label" :value="items.value" :disabled='items.disabled'>
                </el-option>
                <el-option v-show="facilityOff" v-for="items in platformRuleFilterTypelistOff" :key="items.value"
                  :label="items.label" :value="items.value" :disabled='items.disabled'>
                </el-option>
              </el-select>
              <!-- 时间过滤数据 -->
              <el-time-select v-if="item.type == 2" placeholder="起始时间" v-model="item.startTime" :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }">
              </el-time-select>
              <el-time-select v-if="item.type == 2" placeholder="结束时间" v-model="item.endTime" :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }">
              </el-time-select>
              <!-- 持续时长 -->
              <span v-if="item.type == 3">
                <el-input v-model="item.duration" placeholder="请输入状态持续时长"></el-input>
                <el-tooltip class="item" effect="dark" content="单位为分钟,时间范围1-720分钟" placement="right">
                  <i class="el-icon-warning" style="color:red"></i>
                </el-tooltip>
              </span>
              <!-- 设备过滤数据 -->
              <!-- <span class="selectDiv" v-if="item.type==1" @click="showSelect(platformRuleFilterAddDtoLists,item.key)">

                <span> {{item.devName==null?'请选择设备':item.devName}}</span>

                <span v-show="false">{{item.devId}}</span>
              </span> -->

              <!-- 根据设备id获取包体字段 -->
              <el-select v-if="item.devId" v-model="item.devProtocolPacketFieldCode" filterable placeholder="请选择包体属性"
                @change="changePacketField($event, item)">
                <el-option v-for="items in item.packetFieldRuleVoList" :key="items.code" :label="items.name"
                  :value="items.code">
                </el-option>
              </el-select>
              <!-- 比较模式 -->
              <el-select v-if="item.packetFieldDataType == 1" v-model="item.operate" filterable placeholder="请选择比较模式">
                <el-option v-for="items in comparativeModeList" :key="items.value" :label="items.label"
                  :value="items.value">
                </el-option>
              </el-select>
              <el-input v-if="item.packetFieldDataType == 1" v-model="item.startValue" placeholder="请输入比较值"></el-input>
            </div>
            <el-button v-if="!filtrationOff" class="addCreationBtn" plain
              @click="addPlatformRuleFilterAddDto">添加过滤条件</el-button>
          </el-form-item>

          <!--  ***********************执行动作***********************   -->

          <el-form-item label="">
            <div class="trigger">
              <span slot="label">执行动作</span>
              <el-tooltip effect="dark" placement="right-start">
                <i class="el-icon-warning" style="font-size:18px;padding-left: 5px; color:red "></i>
                <div slot="content" class="rightCenter">
                  <div class="describe">
                    <span style="padding-bottom:  10px;">执行动作(当触发条件和过滤条件都满足的情况下执行动作) :</span>
                    <span>①设备输出：当条件满足，执行设备输出，控制设备，可以多个执行动作。 </span>
                    <span>②告警输出：当条件满足，执行告警输出，可在告警中心模块配置告警提醒，只有一个执行动作。</span>
                  </div>
                </div>
              </el-tooltip>
            </div>
            <br />
            <div class="terms" v-for="(item, index) in addForm.platformRuleActionAddDtoList" :key="index">
              <div class="subheading">执行动作{{ index + 1 }}</div>
              <img @click="delPlatformRuleActionAddDto(item, index)" src="../../assets/images/error.png" alt="">
              <el-select v-model="item.type" filterable placeholder="未选择" @change="changeType2($event, item)">
                <el-option v-for="items in platformRuleActionTypelist" :key="items.value" :label="items.label"
                  :value="items.value" :disabled='items.disabled'>
                </el-option>
                <!-- <el-option v-show="facilityOff" v-for="items in platformRuleActionTypelistOff" :key="items.value" :label="items.label" :value="items.value" :disabled='items.disabled'>
                </el-option> -->
              </el-select>
              <!-- 设备输出 -->
              <span class="selectDiv" v-if="item.type == 1" @click="showSelect(platformRuleActionAddDtoLists, item.key)"
                style="width: 300px;">
                <span> {{ item.devName == null ? '请选择设备' : item.devName }}</span><!-- 设备名称-->
                <span v-show="false">{{ item.devId }}</span> <!-- 设备id -->
              </span>
              <!-- 根据设备id获取包体 -->
              <el-select v-if="item.type == 1" v-model="item.devProtocolPacketCode" filterable placeholder="请选择包体"
                @change="changePacket($event, item)">
                <el-option v-for="items in item.packetRuleVoList" :key="items.code" :label="items.name"
                  :value="items.code">
                </el-option>
              </el-select>
              <!-- 包体字段 -->
              <div v-if="item.fieldVoList.length != 0">
                <div class="terms" style="border-bottom:none;padding:0;"
                  v-for="(itemActionField, index) in item.fieldVoList" :key="index">
                  <el-input v-model="itemActionField.name" disabled autocomplete="off" style="margin-top:5px;">
                  </el-input>
                  <el-input v-if="itemActionField.fieldType == 5" v-model="itemActionField.value"
                    placeholder='请输入16进制数据' autocomplete="off" style="margin-top:5px;"></el-input>
                </div>
              </div>
              <!-- 规则输出 -->
              <!-- <el-select v-if="item.type==2" v-model="item.subRuleEngineId" filterable placeholder="请选择规则">
                <el-option v-for="items in platformRuleEngine" :key="items.id" :label="items.name" :value="items.id">
                </el-option>
              </el-select> -->
            </div>
            <el-button v-if="!executeOff" class="addCreationBtn" plain
              @click="addPlatformRuleActionAddDto">添加执行动作</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit">完成</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 选择设备弹框 -->
    <div class="modal-mask" v-if="maskVisible" @click="cancelVisible"></div>
    <div class="deviceSelect changeProject" v-if='selectDevice'>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="line-height:32px">选择设备</span>
          <el-input style="margin:0" class="input-with-select" placeholder="搜索设备名称/编号" v-model="deviceSearch"
            size="small">
            <el-button @click="searchBtn" slot="append" icon="el-icon-search" class="blue"></el-button>
          </el-input>
        </div>
        <div class="textItem">
          <el-row :gutter="24">
            <!-- 左边树形菜单栏 -->
            <el-col :span="8" style="padding-right:0">
              <span style=" display:inline-block;position: relative;line-height: 30px;">设备大类：</span>
              <el-tree style="height:97%;overflow-y: auto;" class="filter-tree" accordion :data="treeList"
                :default-expanded-keys="expansion" :props="defaultProps" node-key="value" :highlight-current="true"
                @node-click="changeTree" :filter-node-method="filterNode" ref="treeData">
              </el-tree>
            </el-col>
            <!-- 右边项目名称 -->
            <el-col :span="16" style="padding-left:0;">
              <el-table height='370px' v-loading="loading" :data="deviceTableData" style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="设备名称"></el-table-column>
                <el-table-column prop="code" label="设备编号"></el-table-column>
                <el-table-column prop="onlineStatus" label="在线状态">
                  <template slot-scope="scope">`
                    <span v-if="scope.row.onlineStatus == 0"> <i class="redDot"></i>离线</span>
                    <span v-else-if="scope.row.onlineStatus == 1"> <i class="greenDot"></i>在线</span>
                    <span v-else>---</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next" :total="total" :pager-count="5">
              </el-pagination>
              <span style="float: right;margin-top: 10px;margin-right: 10px;">
                <el-button @click="cancelVisible">取 消</el-button>
                <el-button type="primary" @click="selectBtn(platformName, key)">确 定</el-button>
              </span>
              <!-- <span style="float: right;margin-top: 10px;margin-right: 10px;" v-if="trigger==3 ||triggerType!=1">
                <el-button @click="cancelVisible">取 消</el-button>
                <el-button type="primary" @click="selectOffline(platformName,key)">确 定</el-button>
              </span> -->
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
  import API from "../../api/api";

  export default {
    data() {
      return {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        key: 0, //用来区分是某个设备框的
        platformName: '', //用来存是那个条件的选择设备的名字
        trigger: '',
        triggerType: '',
        selectDevice: false, //选择设备弹框
        maskVisible: false, // 弹窗mask显示
        platformRuleActionAddDtoLists: 'platformRuleActionAddDtoLists', //用来区分点击的是那个条件的选择设备的名字
        platformRuleFilterAddDtoLists: 'platformRuleFilterAddDtoLists', //用来区分点击的是那个条件的选择设备的名字
        platformRuleTriggerAddDtoLists: 'platformRuleTriggerAddDtoLists', //用来区分点击的是那个条件的选择设备的名字
        offlineAddDtoLists: 'offlineAddDtoLists', //用来区分点击的是那个条件的选择设备的名字
        deviceSearch: '', //弹窗选择设备的搜索
        treeList: [], //选择设备弹框大类数据
        expansion: [], //选择设备弹框默认展开项
        loading: false,
        multipleSelection: [], //选择的设备的id
        deviceTableData: [], //设备列表
        packetFieldRuleVoList: [], //包体字段下拉数据
        categoryId: '', //设备分类id
        showTrigger: false,
        defaultProps: { //tree树状的配置key
          children: 'children',
          label: 'label',
          id: 'id'
        },
        id: this.$route.query.id, //规则id
        strategyId: this.$route.query.strategyId, //策略id
        flag: this.$route.query.flag,
        comparativeModeList: [ //比较模式
          {
            value: 1,
            label: '大于（>）'
          },
          {
            value: 2,
            label: '小于（<）'
          },
          {
            value: 3,
            label: '等于（=）'
          },
          {
            value: 4,
            label: '大于等于（>=）'
          },
          {
            value: 5,
            label: '小于等于（<=）'
          },
          {
            value: 6,
            label: '不等于（!=）'
          },

          {
            value: 7,
            label: '在...之间（between）'
          },
          {
            value: 8,
            label: '不在...之间（notBetween）'
          },
          // {
          //   value: 10,
          //   label: 'no like'
          // },
        ],
        platformRuleTriggerTypelist: [ //触发条件下拉数据
          {
            value: 1,
            label: '设备触发',
            disabled: false
          },
          {
            value: 3,
            label: '设备离线触发',
            disabled: false
          },
        ],
        platformRuleFilterTypelist: [ //过滤条件下拉数据
          {
            value: 2,
            label: '时间过滤',
            disabled: false
          },

        ],
        platformRuleFilterTypelistOff: [ //过滤条件离线触发
          {
            value: 3,
            label: '状态持续时长',
            disabled: false
          },
        ],
        platformRuleActionTypelist: [ //执行动作下拉数据
          {
            value: 1,
            label: '设备输出',
            disabled: false
          },
          {
            value: 3,
            label: '告警输出',
            disabled: false
          }
        ],
        platformRuleActionTypelistOff: [ //执行动作下拉数据离线触发
          {
            value: 3,
            label: '告警输出',
            disabled: false
          },
        ],
        platformRuleEngine: [], //规则下拉数据
        addForm: //设置条件数据
        {
          platformRuleTriggerAddDtoList: [], //触发条件
          platformRuleFilterAddDtoList: [], //过滤条件
          platformRuleActionAddDtoList: [], //默认至少一个执行动作
        },
        rulesInfo: {}, //规则信息
        facilityOff: false, // 是否选择设备离线触发
        filtrationOff: false, // 是否选择过滤条件
        executeOff: false, // 是否选择执行动作

      };
    },
    created() {

    },
    methods: {

      cronConvert() {
        window.open('http://cron.qqe2.com/')
      },
      cronDetail() {
        window.open('http://crontab.org/')
      },

      //初始化

      init() {
        this.getInfo()
        this.getMage() //修改页面
      },
      //获取规则基本信息
      getInfo() {
        this.addForm.platformRuleActionAddDtoList = [{
          ruleEngineId: this.id,
          key: Math.round(Math.random() * 100000000),
          packetRuleVoList: [],
          fieldVoList: [],
          devProtocolPacketCode: '',
          devProtocolPacketId: ''
        }]
        API.platformRuleEngine(this.id).then(res => {
          if (res.code == 1) {
            this.rulesInfo = res.data
          }
        })
        //拿规则列表，必须传策略id
        API.platformRuleEnginePage({
          strategyId: this.strategyId
        }).then(res => {
          if (res.code == 1) {
            this.platformRuleEngine = res.data.resultPage
          }
        })
      },
      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          API.PlatformRuleEngineDetail(id).then(res => {
            if (res.code == 1) {
              this.addForm.platformRuleTriggerAddDtoList = res.data.platformRuleEngineTriggerViewVoList == null ?
                [] : res.data.platformRuleEngineTriggerViewVoList
              this.addForm.platformRuleFilterAddDtoList = res.data.platformRuleEngineFilterViewVoList == null ? [] :
                res.data.platformRuleEngineFilterViewVoList
              this.addForm.platformRuleActionAddDtoList = res.data.platformRuleEngineActionViewVoList == null ? [] :
                res.data.platformRuleEngineActionViewVoList
              this.spark = res.data.platformRuleEngineTriggerViewVoList.map((item) => item.type)
              this.triggerType = this.spark.toString()
              console.log(this.triggerType)
              console.log('  this.addForm', this.addForm)

              let triggertype = this.addForm.platformRuleTriggerAddDtoList[0].type
              // if (triggertype == 3) {
              //   this.facilityOff = true
              //   this.platformRuleTriggerTypelist.forEach(el => {
              //     el.disabled = true
              //   });
              // }
              this.platformRuleTriggerTypelist.forEach(el => {
                if (el.value == triggertype) {
                  el.disabled = false
                } else {
                  el.disabled = true
                }
              })

            }
          })
        }
      },

      //********************************添加，删除条件B********************************************************* */
      //添加触发条件
      addPlatformRuleTriggerAddDto() {
        this.addForm.platformRuleTriggerAddDtoList.push({ //添加一个新的触发条件
          ruleEngineId: this.id,
          key: Math.round(Math.random() * 100000000),
          packetFieldRuleVoList: [],
          devProtocolPacketFieldCode: '',
          devProtocolPacketFieldId: '',
          cron: '',
          startValue: '',
          endValue: '',
          checkOperate: '',
          cronInstruction: '',
          endTime: '',
          endValue: '',
        })
      },
      //删除触发条件(不需要调接口)
      delPlatformRuleTriggerAddDto(row, index) {
        console.log('2222', row, index)
        let _this = this
        //如果是编辑页面就弹框
        // if (this.flag == "edit") {
        _this.$confirm('是否删除该触发条件（点击完成后生效）, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.addForm.platformRuleTriggerAddDtoList.splice(index, 1);
          this.facilityOff = false
          if (this.addForm.platformRuleTriggerAddDtoList.length == 0) {
            this.platformRuleTriggerTypelist.forEach(el => {
              el.disabled = false
            });
            this.addForm.platformRuleFilterAddDtoList = [] //过滤条件
            this.addForm.platformRuleActionAddDtoList = [] //执行动作
            this.executeOff = false
            this.filtrationOff = false
          } else {
            let arr = this.addForm.platformRuleTriggerAddDtoList.every(item => !item.type)
            this.platformRuleTriggerTypelist.forEach(el => {
              if (arr == true) {
                el.disabled = false
              }
            });
            console.log('disabled', this.platformRuleTriggerTypelist);
          }
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //添加过滤条件
      addPlatformRuleFilterAddDto() {
        this.addForm.platformRuleFilterAddDtoList.push({ //添加一个新的过滤条件
          ruleEngineId: this.id,
          key: Math.round(Math.random() * 100000000),
          packetFieldRuleVoList: [],
          devProtocolPacketFieldCode: '',
          devProtocolPacketFieldId: '',
          endTime: '',
          endValue: '',
          startTime: '',
          startValue: '',
        })
      },
      //删除过滤条件(不需要调接口)
      delPlatformRuleFilterAddDto(row, index) {
        let _this = this
        //如果是编辑页面就弹框
        // if (this.flag == "edit") {
        _this.$confirm('是否删除该过滤条件（点击完成后生效）, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.filtrationOff = false
          _this.addForm.platformRuleFilterAddDtoList.splice(index, 1);
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        // } else {
        //   _this.addForm.platformRuleFilterAddDtoList.splice(index, 1);
        // }

      },
      //添加执行动作
      addPlatformRuleActionAddDto() {
        this.addForm.platformRuleActionAddDtoList.push({ //添加一个新的执行动作
          ruleEngineId: this.id,
          key: Math.round(Math.random() * 100000000),
          packetRuleVoList: [],
          fieldVoList: [],
          devProtocolPacketCode: '',
          devProtocolPacketId: '',
        })
      },
      //删除执行动作(不需要调接口)
      delPlatformRuleActionAddDto(row, index) {
        let _this = this

        //如果是编辑页面就弹框
        // if (this.flag == "edit") {
        _this.$confirm('是否删除该执行动作（点击完成后生效）, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.addForm.platformRuleActionAddDtoList.splice(index, 1);
          if (_this.addForm.platformRuleActionAddDtoList.length == 0) {
            this.executeOff = false
          }
          if (this.addForm.platformRuleActionAddDtoList.length == 0) {
            this.platformRuleActionTypelist.forEach(el => {
              el.disabled = false
            });
          } else {
            let arr = this.addForm.platformRuleTriggerAddDtoList.every(item => !item.type)
            this.platformRuleActionTypelist.forEach(el => {
              if (arr == true) {
                el.disabled = false
              }
            });
            console.log('disabled', this.platformRuleTriggerTypelist);
          }
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
        // } else {
        //   _this.addForm.platformRuleActionAddDtoList.splice(index, 1);
        // }

      },
      //********************************添加，删除条件E********************************************************* */


      //*********************************设备搜索页面B ************************************** */
      //显示弹框
      showSelect(name, keys) {
        console.log('弹窗', name, keys)
        this.platformName = name;
        this.key = keys;
        console.log(this.key)
        this.selectDevice = true
        this.maskVisible = true
        this.getTree()

      },
      // 关闭房间详情弹窗
      cancelVisible() {
        this.maskVisible = false
        this.selectDevice = false
      },
      //获取左边设备大类树形数据
      getTree() {
        API.platformDevCategoryDevCategoryList().then(res => {
          let _this = this
          if (res.code == 1) {
            this.treeList = []
            this.treeList.push({
              children: null,
              label: "所有设备",
              parentId: null,
              value: ""
            })


            res.data.devCategoryTreeList.forEach(v => {
              this.treeList.push(v)
            })

            // 异步处理节点默认项
            setTimeout(() => {
              _this.$refs.treeData.setCurrentKey(_this.treeList[0].value); //默认选择第一个节点的父节点
              _this.expansion.push(_this.treeList[0].value) //默认展开第一个节点
            }, 50)
            //默认查第一个父节点的列表
            this.getpageList(_this.treeList[0].value)
          }
        })
      },
      //通过设备分类获取列表
      getpageList(id) {
        let para = {
          code: this.deviceSearch, //搜索栏
          categoryId: id, //设备分类
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        };
        this.loading = true;
        /*显示加载条*/
        API.platformDevDevicePage(para)
          .then(res => {
            if (res.code == 1) {
              this.deviceTableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false;
            /*显示加载条*/
          })

      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //弹框里面搜索的按钮
      searchBtn() {
        this.currentPage == 1
        this.getpageList()
      },
      //选择的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //选择节点刷新右侧信息
      changeTree(row) { //data是节点的数据
        this.getpageList(row.value)
      },
      //选择设备完成后
      selectBtn(name, keys) {
        console.log('name', name)
        // return
        if (this.multipleSelection.length == 0) {
          this.$message.error('请选择设备！')
          return false
        }
        // if (this.multipleSelection.length > 1) {
        //   this.$message.error('只能选择一个设备！')
        // } else if (this.multipleSelection.length == 0) {
        //   this.$message.error('请选择设备！')
        // } else {
        //把设备赋值给当前的对象
        if (name == "platformRuleActionAddDtoLists") { //执行动作
          if (this.multipleSelection.length > 1) {
            this.$message.error('只能选择一个设备！')
            return false
          }
          this.addForm.platformRuleActionAddDtoList.forEach(ele => {
            if (ele.key == keys) {
              ele.devId = this.multipleSelection[0].id
              ele.devName = this.multipleSelection[0].name
              //根据设备id获取包体字段
              API.platformDevProtocolPacketPacket(ele.devId).then(res => {
                if (res.code == 1) {
                  ele.devProtocolPacketCode = '', //为了防止选中的设备改了之后，包体字段选中框也要清空
                    ele.fieldVoList = [],
                    ele.packetRuleVoList = res.data //把包体字段赋值给每一个对象的packetFieldRuleVoList
                }
              })
            }
          })
        } else if (name == "platformRuleTriggerAddDtoLists") { //触发条件
          if (this.multipleSelection.length > 1) {
            this.$message.error('只能选择一个设备！')
            return false
          }
          this.addForm.platformRuleTriggerAddDtoList.forEach(ele => {
            if (ele.key == keys) {
              ele.devId = this.multipleSelection[0].id
              ele.devName = this.multipleSelection[0].name

              //根据设备id获取包体字段
              API.platformDevProtocolPacketFieldPacketField(ele.devId).then(res => {
                if (res.code == 1) {
                  ele.devProtocolPacketFieldCode = '', //为了防止选中的设备改了之后，包体字段选中框也要清空
                    ele.packetFieldRuleVoList = res.data //把包体字段赋值给每一个对象的packetFieldRuleVoList
                }
              })
            }
          })
        } else if (name == 'offlineAddDtoLists') {//设备离线

          this.addForm.platformRuleTriggerAddDtoList.forEach(ele => {
            if (ele.key == keys) {
              this.devId = this.multipleSelection.map((item) => item.id + '-' + item.name)
              this.devName = this.multipleSelection.map((item) => item.name)
              // this.id = this.devId.toString()
              // this.name = this.devName.toString()
              ele.devName = this.devName.toString()
              ele.devId = this.devId.toString()
              console.log(ele.devId)
            }
          })
        } else if (name == "platformRuleFilterAddDtoLists") { //过滤条件
          this.addForm.platformRuleFilterAddDtoList.forEach(ele => {
            if (ele.key == keys) {
              ele.devId = this.multipleSelection[0].id //设备id
              ele.devName = this.multipleSelection[0].name //设备名称
              API.platformDevProtocolPacketFieldPacketField(ele.devId).then(res => {
                if (res.code == 1) {
                  ele.devProtocolPacketFieldCode = '', //为了防止选中的设备改了之后，包体字段选中框也要清空
                    ele.packetFieldRuleVoList = res.data //把包体字段赋值给每一个对象的packetFieldRuleVoList
                }

              })
            }
          })
        } else {
          return false
        }
        this.cancelVisible() //关闭弹框
        // }
      },
      selectOffline(name, keys) {
        if (name == "platformRuleTriggerAddDtoLists") { //触发条件
          this.addForm.platformRuleTriggerAddDtoList.forEach(ele => {
            if (ele.key == keys) {
              // ele.devName = this.multipleSelection

              ele.devId = this.multipleSelection.map((item) => item.id)
              this.devName = this.multipleSelection.map((item) => item.name)
              ele.devName = this.devName.toString()
              console.log(ele.devName)
            }
          })
        }

        this.cancelVisible() //关闭弹框

      },
      //*********************************设备搜索页面E ************************************** */
      //监听选中触发类型，改变选中类型初始化数据（触发条件）
      changeType(val, item) {
        console.log(val, item)
        this.trigger = val
        if (val == 1) {
          item.cron = ''
          item.cronInstruction = ''
          item.devId = ''
          item.devName = null
          item.startValue = ''
          item.endValue = ''
        } else if (val == 2) {
          item.packetFieldRuleVoList = [],
            item.devProtocolPacketFieldCode = ''
          item.packetFieldDataType = 10;
          item.devId = ''
          item.devName = null
          item.startValue = ''
          item.endValue = ''
        } else if (val == 3) {
          item.cron = ''
          item.cronInstruction = ''
          item.packetFieldRuleVoList = [],
            item.devProtocolPacketFieldCode = ''
          item.packetFieldDataType = 10;
          item.devId = ''
          item.devName = null
          item.startValue = ''
          item.endValue = ''
          this.facilityOff = true
        }
        this.platformRuleTriggerTypelist.forEach(el => {
          if (el.value == val) {
            el.disabled = false
          } else {
            el.disabled = true
          }
        })
      },
      //监听选中触发类型，改变选中类型初始化数据（过滤条件）
      changeType1(val, item) {
        console.log('disabled', val)
        if (val == 1) {
          item.startTime = ''
          item.endTime = ''
        } else if (val == 2) {
          item.packetFieldRuleVoList = [],
            item.devProtocolPacketFieldCode = ''
          item.packetFieldDataType = 10;
          item.devId = ''
          item.devName = null
          item.startValue = ''
          item.endValue = ''
        } else if (val == 3) {
          // item.packetFieldRuleVoList = [],
          //   item.devProtocolPacketFieldCode = ''
          // item.packetFieldDataType = 10;
          // item.devId = ''
          // item.devName = null
          // item.startValue = ''
          // item.endValue = ''
          this.filtrationOff = true
        }

        this.platformRuleFilterTypelist.forEach(el => {
          if (el.value == val) {
            el.disabled = false
          } else {
            el.disabled = true
          }
        })
      },
      //监听选中触发类型，改变选中类型初始化数据（执行动作）
      changeType2(val, item) {
        if (val == 1) {
          item.subRuleEngineId = ''
        } else if (val == 2) {
          item.packetRuleVoList = [],
            item.devProtocolPacketCode = ''
          item.devId = ''
          item.devName = null
          item.fieldVoList = []
        } else if (val == 3) {
          // item.packetRuleVoList = [],
          //   item.devProtocolPacketCode = ''
          // item.devId = ''
          // item.devName = null
          // item.fieldVoList = []
          this.executeOff = true
        }

        this.platformRuleActionTypelist.forEach(el => {
          if (el.value == val) {
            el.disabled = false
          } else {
            el.disabled = true
          }
        })
      },

      //监控选中完包体字段（公用）
      changePacketField(event, row) {
        row.packetFieldRuleVoList.forEach(ele => {
          if (ele.code == event) {
            row.devProtocolPacketFieldId = ele.id
            row.packetFieldDataType = ele.dataType
          }
        });
      },
      //监听选中包体后调接口获取字段（执行动作）
      changePacket(event, row) {
        let packetId;
        console.log(event, row.packetRuleVoList);
        row.packetRuleVoList.forEach(ele => {
          if (ele.code == event) {
            row.devProtocolPacketId = ele.id
            packetId = ele.id
          }
        });
        //获取到当前选中的包体id调用查询包体字段的接口
        API.platformDevProtocolPacketFieldPacketFieldPacketId(packetId).then(res => {
          if (res.code == 1) {
            row.fieldVoList = res.data //包体字段
          }
        })


      },

      //完成规则
      onSubmit() {
        // 触发校验
        let list = this.addForm.platformRuleTriggerAddDtoList
        for (let i = 0; i < list.length; i++) {
          console.log('数据1111', list)
          if (list.length == 0 || !list[i].type || !list[i].devId) {
            this.$message.error('触发条件必填项不能为空')
            return;
          } else if (list[i].type == 1) {
            if (!list[i].devProtocolPacketFieldCode) {
              this.$message.error('触发条件包体属性为必选项')
              return
            } else if (list[i].packetFieldDataType == 1 && !list[i].checkOperate) {
              this.$message.error('触发条件比较模式为必选项')
              return
            } else if (list[i].checkOperate != 8 && !list[i].startValue) {
              this.$message.error('触发条件比较值为必填项')
              return
            } else if (list[i].checkOperate == 8 && !list[i].startValue && !list[i].endValue) {
              this.$message.error('触发条件开始值和结束值为必填项')
              return
            }
          }
        }

        // 过滤校验
        let filterlist = this.addForm.platformRuleFilterAddDtoList
        if (filterlist.length == 0 || !filterlist[0].type) {
          this.$message.error('过滤条件必填项不能为空')
          return
        } else {
          if (filterlist[0].type == 1) {
            const filtertype = filterlist.some(item => !item.startTime || !item.endTime);
            if (filtertype == true) {
              this.$message.error('过滤条件必填项不能为空')
              return
            }
          } else if (filterlist[0].type == 3) {
            const filtertype = filterlist.some(item => !item.duration);
            if (filtertype == true) {
              this.$message.error('过滤条件必填项不能为空')
              return
            }


          }

        }
        // 执行校验
        let actionlist = this.addForm.platformRuleActionAddDtoList
        if (actionlist.length == 0 || !actionlist[0].type) {
          this.$message.error('执行动作必填项不能为空')
          return
        } else {
          const actiontype = actionlist.some(item => !item.devId || !item.devProtocolPacketCode);
          if (actionlist[0].type == 1) {
            if (actiontype == true) {
              this.$message.error('执行动作必填项不能为空')
              return
            }
          }
        }
        var verifySuccess = true;
        if (this.addForm.platformRuleTriggerAddDtoList.length != 0) {
          this.addForm.platformRuleTriggerAddDtoList.forEach((element, index) => {
            if (element.type == 2) {
              if (element.cron == '') {
                this.$message.error('cron表达式不能为空');
                verifySuccess = false
                return false;
              }
            }
          });
        }
        if (!verifySuccess) {
          return false;
        }
        console.log(this.addForm)
        // return
        API.addPlatformRuleEngineDetail(this.addForm).then(res => {
          if (res.code == 1) {
            this.$message.success('创建成功')
            this.$router.push({
              path: "/rules/ruleEngineList",
              query: {
                id: this.strategyId
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })

      },

      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getpageList()
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getpageList()
      },
      getcheck() {

      },
      //修改规则
      async editOnSubmit() {
        // 触发校验
        let list = this.addForm.platformRuleTriggerAddDtoList
        for (let i = 0; i < list.length; i++) {
          console.log('数据', list, list[i].packetFieldDataType)
          if (list.length == 0 || !list[i].type || !list[i].devId) {
            this.$message.error('触发条件必填项不能为空')
            return;
          } else if (list[i].type == 1) {
            if (!list[i].devProtocolPacketFieldCode) {
              this.$message.error('触发条件包体属性为必选项')
              return
            } else if (list[i].packetFieldDataType == 1 && !list[i].checkOperate) {
              this.$message.error('触发条件比较模式为必选项')
              return
            } else if (list[i].packetFieldDataType == 1 && !list[i].startValue) {
              this.$message.error('触发条件必填项不能为空')
              return
            } else if (list[i].checkOperate == 7 && list[i].packetFieldDataType == 1 && !list[i].endValue || list[i].checkOperate == 8) {
              this.$message.error('触发条件必填项不能为空')
              return
            }
          }
        }


        // 过滤校验
        let filterlist = this.addForm.platformRuleFilterAddDtoList
        if (filterlist.length == 0 || !filterlist[0].type) {
          this.$message.error('过滤条件必填项不能为空')
          return
        } else {
          if (filterlist[0].type == 1) {
            const filtertype = filterlist.some(item => !item.startTime || !item.endTime);
            if (filtertype == true) {
              this.$message.error('过滤条件必填项不能为空')
              return
            }
          } else if (filterlist[0].type == 3) {
            const filtertype = filterlist.some(item => !item.duration);
            if (filtertype == true) {
              this.$message.error('过滤条件必填项不能为空')
              return
            }
          }
        }
        // 执行校验
        let actionlist = this.addForm.platformRuleActionAddDtoList
        if (actionlist.length == 0 || !actionlist[0].type) {
          this.$message.error('执行动作必填项不能为空')
          return
        } else {
          if (actionlist[0].type == 1) {
            const actiontype = actionlist.some(item => !item.devId || !item.devProtocolPacketCode);
            if (actiontype == true) {
              this.$message.error('执行动作必填项不能为空')
              return
            }
          }
        }

        this.addForm.ruleEngineId = this.id
        console.log(this.addForm)
        // return
        API.editPlatformRuleEngineDetailUpdate(this.addForm).then(res => {
          if (res.code == 1) {
            this.$message.success('修改成功')
            this.$router.push({
              path: "/rules/ruleEngineList",
              query: {
                id: this.strategyId
              }
            })
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error'
            });
          }
        })
      },
    },
    mounted() {
      this.init();
    }
  };

</script>
<style scoped>
  .selectDivdevName {
    display: inline-flex;
    cursor: pointer;
    padding: 0 30px 0 15px;
    vertical-align: -1px;
    width: 50%;
    line-height: 40px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    margin-left: 10px;
    overflow-y: scroll;
  }

  .selectDiv {
    white-space: nowrap;
    overflow: auto;
    margin-bottom: -13px;
    padding-left: 10px;
  }

  .selectDiv::-webkit-scrollbar {
    display: none;
  }

  .trigger {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
  }

  .rightCenter {
    /* width: 60%; */
    display: flex;
    /* justify-content: space-between; */
    flex-direction: column;
    flex-wrap: wrap;
  }

  .describe {
    /* width: 270px; */
    display: flex;
    flex-direction: column;
    padding-right: 5px;
  }

  .trigger span {
    font-weight: bold;
    font-size: 15px;
    color: #4a4a4a;
  }

  .head span {
    /* font-weight: bold; */
    color: #fff;
    font-size: 13px;
  }

  .el-tooltip__popper>>>.is-dark {
    top: 165px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/platform/ruleCondition.vue